import { MODAL_AUTH } from '@components/App/Modal/constants'
import Modal from '@components/App/Modal/Modal'
import { ROUTE_PAGE_HOME } from '@components/Router/constants'
import { Button } from '@octopus-do/octopus-storybook'
import { OctopusBlueLogo } from '@octopus-do/octopus-storybook/icons'
import { openModal } from '@storeOld/reducers/ui'
import type React from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import css from './styles.module.css'

export const GuestGate: React.FC = () => {
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()

  const openAuthModal = () => {
    // @ts-expect-error
    dispatch(openModal(MODAL_AUTH, { redirectAfterAuth: pathname + search }))
  }

  useEffect(() => {
    openAuthModal()
  }, [])

  return (
    <div className={css.container}>
      <Link className={css.logo} to={ROUTE_PAGE_HOME}>
        <OctopusBlueLogo />
      </Link>
      <div className={css.heading}>Log in to view this page</div>
      <Button label="Log in" onClick={openAuthModal} />
      <Modal />
    </div>
  )
}
